import React, { Component } from 'react';

export class Where extends Component {

    handleChange = changeEvent => {
        const name = changeEvent.target.name;
        const value = changeEvent.target.value;

        this.props.specificChanges(name, value);
    }

    render() {
        return (
            <div className="form-horizontal row spacer">
                <label className="control-label col-sm-4" htmlFor="Where">Where did the incident occur?</label>
                <div className="col-sm-8">
                    <div className="form-horizontal">
                        <label>
                            <input className="form-check-input" type="radio" name="whereOccur" value="outside"
                                onChange={this.handleChange}
                            />
                            Outside
                        </label>
                    </div>
                    <div className="form-horizontal">
                        <label>
                            <input className="form-check-input" type="radio" name="whereOccur" value="inside"
                                onChange={this.handleChange}
                            />
                            Inside
                        </label>
                    </div>
                </div>
            </div >
        );
    }
}
export default Where;



// WEBPACK FOOTER //
// ./src/components/questions/Where.jsx